// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var distributionRouter = {
  path: '/distribution',
  component: Layout,
  redirect: '/distribution/distributionconfig',
  name: 'Distribution',
  meta: {
    title: '分销',
    icon: 'clipboard'
  },
  children: [{
    path: 'index',
    component: function component() {
      return import('@/views/distribution/index');
    },
    name: 'distributionIndex',
    meta: {
      title: '分销员管理',
      icon: ''
    }
  }, {
    path: 'audit',
    component: function component() {
      return import('@/views/distribution/audit/index');
    },
    name: 'distributionAudit',
    meta: {
      title: '待审核',
      icon: ''
    }
  }, {
    path: 'codeManage',
    component: function component() {
      return import('@/views/distribution/code/index');
    },
    name: 'distributionCode',
    meta: {
      title: '分销码管理',
      icon: ''
    }
  }, {
    path: 'distributionconfig',
    component: function component() {
      return import('@/views/distribution/config/index');
    },
    name: 'distributionConfig',
    meta: {
      title: '分销配置',
      icon: ''
    }
  }, {
    path: 'distributionSetting',
    component: function component() {
      return import('@/views/distribution/setting/index');
    },
    name: 'distributionSetting',
    meta: {
      title: '分销设置',
      icon: ''
    }
  }, {
    path: 'distributionLevel',
    component: function component() {
      return import('@/views/distribution/level/index');
    },
    name: 'distributionLevel',
    meta: {
      title: '分销员等级',
      icon: ''
    }
  }, {
    path: 'product',
    component: function component() {
      return import('@/views/distribution/product/index');
    },
    name: 'distributionProduct',
    meta: {
      title: '分销员品',
      icon: ''
    }
  }, {
    path: 'product/setting',
    component: function component() {
      return import('@/views/distribution/product/form');
    },
    name: 'distributionProductSetting',
    meta: {
      title: '设置分佣',
      icon: '',
      hidden: true,
      activeMenu: '/distribution/product'
    }
  }, {
    path: 'closing',
    component: function component() {
      return import('@/views/distribution/closing/index');
    },
    name: 'distributionClosing',
    meta: {
      title: '提现管理',
      icon: ''
    }
  }, {
    path: 'level/add',
    component: function component() {
      return import('@/views/distribution/level/form');
    },
    name: 'distributionLevelAdd',
    meta: {
      title: '新增分销员等级',
      icon: '',
      hidden: true,
      activeMenu: '/distribution/distributionLevel'
    }
  }, {
    path: 'level/edit',
    component: function component() {
      return import('@/views/distribution/level/form');
    },
    name: 'distributionLevelEdit',
    meta: {
      title: '编辑分销员等级',
      icon: '',
      hidden: true,
      activeMenu: '/distribution/distributionLevel'
    }
  }]
};
export default distributionRouter;